module.exports = __webpack_public_path__ + "img/Delete Extra.bf66c300.png";